import React from 'react';
import { BookCover } from './BookCover';
import { VOLUMES } from '../data/product';
const tilt = ['-rotate-6 translate-y-4', '-rotate-3 translate-y-1.5', '-rotate-1', 'rotate-1', 'rotate-3 translate-y-1.5', 'rotate-6 translate-y-4'];

/**
 * Code-drawn stand-in for the product mockup: the six volumes fanned out.
 * Replaced automatically once PRODUCT_MOCKUP in data/product.ts has a URL.
 */
export function ProductStack({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="The six Court Ready volumes" className={`flex items-end justify-center px-2 py-6 ${className}`} data-id="element-216" data-mp="ibjoiq0tpwos">
      {VOLUMES.map((v, i) => <div key={v.number} className={`w-[19%] ${i === 0 ? '' : '-ml-[4%]'} ${tilt[i]}`} style={{
      zIndex: i < 3 ? i + 1 : 6 - i
    }} data-id="element-217" data-mp="r456i3wmrzck" data-mpi={i}>
          <BookCover size="sm" kicker={`Volume ${v.number}`} number={v.number} title={v.title} accent={v.accent} data-id="element-218" data-mp="w1dfpezswt1o" />
        </div>)}
    </div>;
}